import { clickCalendarEvent, doubleClickCalendarEvent } from '../actions/publicActions';
import { clickGridEvent, DayGridScenario, doubleClickGridEvent } from 'owa-day-grid';
import { orchestrator } from 'satcheljs';

export const clickGridEventOrchestrator = orchestrator(clickGridEvent, actionMessage => {
    const { id, scenario } = actionMessage;
    if (scenario === DayGridScenario.TimePanelConflictsView) {
        clickCalendarEvent(id);
    }
});

export const doubleClickGridEventOrchestrator = orchestrator(
    doubleClickGridEvent,
    actionMessage => {
        const { id, scenario } = actionMessage;
        if (scenario === DayGridScenario.TimePanelConflictsView) {
            doubleClickCalendarEvent(id);
        }
    }
);
